export default __webpack_public_path__ + "static/media/solution_92.5d62c867.png";